import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUri, filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
};

export const getVideos = createAsyncThunk(
  "videos/getVideos",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const filter = filterRequest(args.filter);
      const { data } = await axios.get(
        `${apiUri}/reels?page=${page}&size=${size}&query=${query}${filter}`,
        {
          headers: {
            "Content-Type": "application/json",
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          },
        }
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      console.log(errors);
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createVideo = createAsyncThunk(
  "videos/createVideo",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.post(`${apiUri}/reels`, args, {
        headers: {
          "Content-Type": "multipart/form-data",
          "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
          "Accept-Language": document.documentElement.lang,
        },
      });
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateVideo = createAsyncThunk(
  "videos/updateVideo",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.put(
        `${apiUri}/reels/${args._id}/status`,
        args.values,
        {
          headers: {
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          },
        }
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const deleteVideo = createAsyncThunk(
  "videos/deleteVideo",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.delete(`${apiUri}/reels/${args._id}`, {
        headers: {
          "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
          "Accept-Language": document.documentElement.lang,
        },
      });
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const videosSlice = createSlice({
  name: "videos",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getVideos.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getVideos.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data?.data;
        state.itemsCount = payload.data?.itemsCount;
        state.pages = payload.data?.pages;
        state.error = null;
      })
      .addCase(getVideos.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(createVideo.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createVideo.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data.push(payload.data);
        state.itemsCount++;
        state.error = null;
      })
      .addCase(createVideo.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateVideo.pending, (state) => {
        state.isLoading = true;
        // state.error = null;
      })
      .addCase(updateVideo.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        // const indexAt = state.data.findIndex(
        //   (el) => el._id === payload.data._id
        // );
        // if (indexAt !== -1) {
        //   state.data[indexAt] = payload.data;
        // }
        // state.error = null;
      })
      .addCase(updateVideo.rejected, (state, { payload }) => {
        state.isLoading = false;
        // state.error = payload?.message;
      })

      .addCase(deleteVideo.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteVideo.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        // state.data = state.data.filter((el) => el._id !== payload.data._id);
        state.error = null;
      })
      .addCase(deleteVideo.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      });
  },
});

export default videosSlice.reducer;
